<template>
<div>
    <b-form @submit.prevent="DELRow">
        <b-row>
            <b-col>
                <div class="card-wrapper">
                    <card class="shadow-lg p-4">
                        <!-- NAMA -->
                        <b-row class="mb-2">
                            <b-col sm="4" class="font-weight-bold text-dark">NAMA</b-col>
                            <b-col sm="1">:</b-col>
                            <b-col sm="7">{{ listRow.CONm }}</b-col>
                        </b-row>

                        <!-- NO KP -->
                        <b-row class="mb-2">
                            <b-col sm="4" class="font-weight-bold text-dark">NO KAD PENGENALAN</b-col>
                            <b-col sm="1">:</b-col>
                            <b-col sm="7">{{ listRow.NoKP }}</b-col>
                        </b-row>

                        <!-- KATEGORI -->
                        <b-row class="mb-2">
                            <b-col sm="4" class="font-weight-bold text-dark">KATEGORI</b-col>
                            <b-col sm="1">:</b-col>
                            <b-col sm="7">{{ listRow.Kategori }}</b-col>
                        </b-row>

                        <!-- AGENSI -->
                        <b-row class="mb-2">
                            <b-col sm="4" class="font-weight-bold text-dark">AGENSI</b-col>
                            <b-col sm="1">:</b-col>
                            <b-col sm="7">{{ listRow.Agensi }}</b-col>
                        </b-row>

                        <!-- PEGAWAI -->
                        <b-row class="mb-4">
                            <b-col sm="4" class="font-weight-bold text-dark">PEGAWAI PENGIRA</b-col>
                            <b-col sm="1">:</b-col>
                            <b-col sm="7">{{ listRow.PegPengira }}</b-col>
                        </b-row>

                        <!-- ACTION BUTTONS -->
                        <b-row>
                            <b-col md="12" class="text-md-right">
                                <!-- Button Terima hanya keluar bila fromAction === 'terima' -->
                                <base-button v-if="fromAction === 'terima'" size="sm" type="success" @click="confirmTerima">
                                    <i class="fa fa-check"></i> TERIMA
                                </base-button>

                                <!-- Button Batal -->
                                <base-button size="sm" type="danger" @click="$emit('batal')">
                                    BATAL
                                </base-button>
                            </b-col>
                        </b-row>
                    </card>
                </div>
            </b-col>
        </b-row>
    </b-form>
</div>
</template>

<script>
import swal from "sweetalert2";

export default {
    props: {
        listRow: {
            type: Object,
            required: true,
        },
        fromAction: { type: String, default: "" } // "lihat" / "terima"
    },
    methods: {
        batal() {
            this.$emit("batal");
        },
        confirmTerima() {
            swal.fire({
                title: "Pengesahan",
                text: "Adakah anda pasti mahu TERIMA permohonan ini?",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Ya, Terima",
                cancelButtonText: "Batal",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$emit("terima", this.listRow);

                    swal.fire("Berjaya!", "Permohonan telah diterima.", "success").then(() => {
                        this.$router.push({
                            name: 'BUTIRAN MAKLUMAT PERIBADI',
                            params: {
                                ICNo: 830512065661,
                            }
                        })
                    });
                }
            });
        }
    },
};
</script>
